var map = {
	"./JavaScript_logo.svg": 3095,
	"./abax_2_data_from_db.png": 1727,
	"./abax_2_predict.png": 5264,
	"./abax_2_predict_changes_temp.png": 8311,
	"./abax_2_predict_config.png": 9380,
	"./abax_2_predict_history.png": 6182,
	"./bootstrap_logo.png": 2423,
	"./c_sharp.png": 2654,
	"./css3_logo.png": 2402,
	"./dalle-abax2_predict.jpg": 5993,
	"./dalle-bitrate.jpg": 8005,
	"./dalle-cctv-resolutions.jpg": 302,
	"./dalle-city-space-speed.webp": 1292,
	"./dalle-cityspace-future.webp": 8559,
	"./dalle-clc_hdd.jpg": 1456,
	"./dalle-hdd-p.jpg": 8669,
	"./dalle-landspace-lake.webp": 397,
	"./dalle-low-of-resolitions.jpg": 4530,
	"./dalle-realistic-landspace.jpg": 759,
	"./dalle-realistic-urban.webp": 9513,
	"./dalle_programmers.jpg": 375,
	"./dofinansowaniaslask.jpg": 9691,
	"./emiternet_pl.jpg": 6962,
	"./helpdesk.jpg": 9794,
	"./html_5.png": 9558,
	"./jquery_logo.png": 6721,
	"./kamil_knap.jpg": 7733,
	"./keno-home.jpg": 3699,
	"./kkn_company.jpg": 6092,
	"./logo.png": 6949,
	"./logo_kkn.png": 7929,
	"./logo_kkn_black.png": 9798,
	"./mongodb_logo.png": 4369,
	"./mysql_logo.png": 179,
	"./nodejs.png": 8385,
	"./osiedle_idylla.jpg": 6911,
	"./php_logo.png": 527,
	"./python_logo.jpg": 1208,
	"./sass_logo.png": 4442,
	"./sklep_next-reklama.jpg": 5153,
	"./speedmeeting.jpg": 7428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;